import Button, { ButtonProps } from "@mui/material/Button";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import Stack, { Row } from "@rui/Stack";

export const DeepDiveSectionHeader = styled(Stack)(({ theme }) => ({
  minHeight: "28px",
  gap: theme.spacing(1),
  paddingBottom: theme.spacing(1.5),
  [theme.breakpoints.up("mobile")]: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: theme.spacing(1),
  },
}));

export const DeepDiveSectionHeading = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodySecondaryMed,
  color: theme.palette.shades.neutral[500],
  textTransform: "uppercase",
  [theme.breakpoints.down("mobile")]: {
    display: "none",
  },
}));

export const DeepDiveMenuButton = styled((props: ButtonProps) => (
  <Button disableRipple variant="outlined" {...props} />
))(({ theme }) => ({
  borderColor: theme.palette.shades.neutral[100],
  color: theme.palette.shades.neutral[500],
  borderRadius: "4px",
  height: "28px",
  minHeight: "28px",
  padding: "4px 10px",
  width: "fit-content",
  "& svg": {
    height: "16px",
    width: "16px",
  },
}));

export const DeepDiveStandingsKeyContainer = styled(Row)(({ theme }) => ({
  [theme.breakpoints.down("mobile")]: {
    paddingLeft: theme.spacing(1),
  },
}));
